var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checked)?_c('v-icon',{staticClass:"align-middle",class:_vm.checkmarkClass,attrs:{"size":_vm.size}},[_vm._v("mdi-check-circle")]):_c('v-icon',{staticClass:"align-middle text-muted",attrs:{"size":_vm.size}},[_vm._v("mdi-circle")])}
var staticRenderFns = []

export { render, staticRenderFns }